// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 268 ? "component---src-templates-basic-js" : chunkId) + "-" + {"127":"7a887335cd96e97cf251","268":"9f5ae5227d9434414682"}[chunkId] + ".js";
};